import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app.js";
import { poseLeTitre } from "./lexique/langue.js";
import { poseLAgentDeService } from "./reseau.js";
import { FournisseurDeSession } from "./session.js";

import "./styles/polices.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/matiere.css";
import "./styles/dessin.css";
import "./styles/ecrans.css";

const racine = document.getElementById("reliure");
if (!racine) throw new Error("La reliure n'a pas de dos : #reliure est absent du document.");

poseLeTitre();
poseLAgentDeService();

createRoot(racine).render(
  <StrictMode>
    <FournisseurDeSession>
      <App />
    </FournisseurDeSession>
  </StrictMode>
);
